import { render, staticRenderFns } from "./SolicitarLote.vue?vue&type=template&id=20e65e8d&scoped=true&"
import script from "./SolicitarLote.vue?vue&type=script&lang=js&"
export * from "./SolicitarLote.vue?vue&type=script&lang=js&"
import style0 from "./SolicitarLote.vue?vue&type=style&index=0&id=20e65e8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e65e8d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VForm,VMain,VRow})
